import { render, staticRenderFns } from "./Breadcrumb3.vue?vue&type=template&id=fa88c0e0&scoped=true&"
import script from "./Breadcrumb3.vue?vue&type=script&lang=js&"
export * from "./Breadcrumb3.vue?vue&type=script&lang=js&"
import style0 from "./Breadcrumb3.vue?vue&type=style&index=0&id=fa88c0e0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa88c0e0",
  null
  
)

export default component.exports